import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import { FILTER_PARAMS,filterSearchKey } from 'components/zpFilter/filterUtils';

import { generateRandomKey } from '../../../utils';

const CompanyClusterFooter = (props) => {
  const { linksData, isHeaderTextH3 } = props;

  const linkClicked = (filterData = {}) => {
    if (filterData.jobTitle) {
      localStorage.setItem(
        filterSearchKey,
        JSON.stringify({
          [FILTER_PARAMS.JOB_TITLE]: [filterData.jobTitle],
        })
      );
    }

    return true;
  };

  return (
    <div className="row company-cluster-footer">
      {linksData
        ?.filter((x) => x?.links?.length)
        ?.map(({ title, links }, index) => {
          return (
            <div key={generateRandomKey()} className={classNames('col-12 col-lg-3', { 'z-mt-36 z-mt-lg-0': index > 0 })}>
              {isHeaderTextH3 ? (
                <h3 className="footer-link-list-title">{title}</h3>
              ) : (
                <div className="footer-link-list-title">{title}</div>
              )}
              <ul className="footer-link-list">
                {links.map(({ rel, link, text, title, filterData }, index) => (
                  <li key={index} className={`footer-link-list-item`}>
                    <a
                      rel={rel}
                      href={link}
                      title={title}
                      onClick={() => linkClicked(filterData || {})}
                      onAuxClick={() => linkClicked(filterData || {})} // when user open link in new tab with middle mouse click
                      onContextMenu={() => linkClicked(filterData || {})} // when user open link in new tab with right click context menu
                    >
                      {text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
    </div>
  );
};

CompanyClusterFooter.propTypes = {
  linksData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
    })
  ),
  totalColumnsInRow: PropTypes.number,
  isHeaderTextH3: PropTypes.bool
};

CompanyClusterFooter.defaultProps = {
  linksData: [],
  totalColumnsInRow: 4,
  isHeaderTextH3: true
};

export default CompanyClusterFooter;
